import api, { Notifiable } from './api';

export interface DistribuicaoRequisitado {
  resultDataTabel: RequisitadoAno[];
  anos: number[];
}

export interface RequisitadoAno {
  pcmId: string;
  requisicaoCompraSeqId: string;
  ordemInvestimentoId: string;
  ordemInvestimentoRequisicaoCompraSeqId: string;
  moduloEconomicoContratadoId: string;
  ordemCompraId: string;

  ordemInvestimentoRequisicaoCompraSeqPrincial: boolean;

  pacoteProjeto: string;
  pacotePctOi: string;

  requisicaoCompraNumero: number;
  requisicaoCompraSeq: string;
  requisicaoCompraPrecoUnitarioFormatado: string;
  requisicaoCompraPrecoUnitario: number;
  requisicaoCompraQuantidadeTotal: string;
  requisicaoCompraValorTotal: number;
  requisicaoCompraValorTotalFormatado: string;
  requisicaoCompraOc: string;

  pedidoPcm: string;
  pedidoCtPcs: string;
  pedidoCtPreUnitarioFormatado: string;
  valorUnitarioPedido: number;

  valorFormatado: string;
  quantidadeFormatado: string;
}

export const getAllRequisitadoAno = (id: any) =>
  api.get<DistribuicaoRequisitado>(`requisitadoOc/getAllRequisitadoAno/${id}`);

export const getAllRequisitadoAnoRc = (id: any) =>
  api.get<DistribuicaoRequisitado>(`requisitadoOc/getAllRequisitadoAnoRc/${id}`);

//export const deleteRequisitadoAno = (id: any) => api.delete(`requisitadoOc/deleteRequisitadoAno/${id}`);

export const deleteRequisitadoAno = (id: any) => api.get<Notifiable>(`requisitadoOc/deleteRequisitadoAno/${id}`);

export const adcionarLinhaItemRateavelRequisitadoAno = (
  ordemInvestimentoId: any,
  ordemInvestimentoRequisicaoCompraSeqId: string,
) => {
  const form = new FormData();
  form.append('ordemInvestimentoId', ordemInvestimentoId);
  form.append('ordemInvestimentoRequisicaoCompraSeqId', ordemInvestimentoRequisicaoCompraSeqId);

  return api.post<any>(`requisitadoOc/adcionarLinhaItemRequisitadoAno`, form);
};

export const adcionarColunaItemRateavelRequisitadoAno = (ordemInvestimentoRequisicaoCompraSeqId: any) => {
  const form = new FormData();
  form.append('ordemInvestimentoRequisicaoCompraSeqId', ordemInvestimentoRequisicaoCompraSeqId);

  return api.post<any>(`requisitadoOc/adcionarColunaItemRequisitadoAno`, form);
};

export const adcionarColunaItemRequisitadoAnoRc = (ordemInvestimentoRequisicaoCompraSeqId: any) => {
  const form = new FormData();
  form.append('ordemInvestimentoRequisicaoCompraSeqId', ordemInvestimentoRequisicaoCompraSeqId);

  return api.post<any>(`requisitadoOc/adcionarColunaItemRequisitadoAnoRc`, form);
};

export const atualizarValorRequisitadoAno = (
  ordemInvestimentoRequisicaoCompraSeqId: any,
  valorAlterado: string,
  ano: string,
) => {
  const form = new FormData();
  form.append('ordemInvestimentoRequisicaoCompraSeqId', ordemInvestimentoRequisicaoCompraSeqId);
  form.append('valorAlterado', valorAlterado);
  form.append('valorAlteradoDecimal', valorAlterado);
  form.append('ano', ano);
  form.append('anoTexto', ano);

  return api.post<any>(`requisitadoOc/atualizarValorRequisitadoAno`, form);
};

export const concluirRateioOcRc = (ordemInvestimentoRequisicaoCompraSeqId: string) => {
  const form = new FormData();
  form.append('ordemInvestimentoRequisicaoCompraSeqId', ordemInvestimentoRequisicaoCompraSeqId);
  return api.post<any>(`requisitadoOc/concluirRateioOcRc`, form);
};
